import React, { Suspense } from 'react';
import { Switch } from 'react-router-dom';
import CopyRight from 'component/CopyRight';
import RouteWithSubRoutes from 'component/RouteWithSubRoutes';
import routes from './routeConfig';
import cooperationSDK from '../lib/cooperationSdk';
import AsyncComponent from 'component/AsyncComponent';
import Loading from 'component/Loading';

const App: React.FC = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        {routes.map((route) => {
          return <RouteWithSubRoutes exact key={route.path} {...route} />;
        })}
      </Switch>
      <CopyRight />
    </Suspense>
  );
};

const getTokenBefore = new Promise((resolve, reject) => {
  if (cooperationSDK.isCoEnv) {
    Promise.all([cooperationSDK.fetchUserToken(), cooperationSDK.fetchUserInfo()])
      .then(() => {
        resolve(null);
      })
      .catch((e) => {
        return reject(e);
      });
    return;
  }

  resolve(null);
});

const AuthApp = () => <AsyncComponent aysncFn={getTokenBefore} asyncComponent={<App />} />;

export default AuthApp;
